import { Button, useToast } from "@chakra-ui/react";
import { clearApiCacheForTab } from "../../api/api";

/**
 * Clears the persisted + in-memory GET cache for this dashboard section only
 * (localStorage + Redux), so the next `hitBeApi` call fetches from the network.
 *
 * @param {string} tabId Route segment under `/dashboard/…` (e.g. `notes`, `project`, `daily-chore`, `home`).
 * @param {boolean} [onGradient] Styling for dark gradient heroes
 */
const TabCacheButton = ({ tabId, onGradient, size = "sm" }) => {
  const toast = useToast();

  const onClear = () => {
    const n = clearApiCacheForTab(tabId);
    if (n > 0) {
      toast({
        title: "Cache cleared for this page",
        description: `${n} cached response${n === 1 ? "" : "s"} removed. Data will load fresh from the server.`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } else {
      toast({
        title: "No cached data for this page",
        description: "There was nothing in storage, or it was already cleared.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (onGradient) {
    return (
      <Button
        type="button"
        size={size}
        colorScheme="whiteAlpha"
        bg="whiteAlpha.200"
        _hover={{ bg: "whiteAlpha.300" }}
        flexShrink={0}
        onClick={onClear}
      >
        Clear page cache
      </Button>
    );
  }

  return (
    <Button type="button" size={size} variant="outline" colorScheme="orange" flexShrink={0} onClick={onClear}>
      Clear page cache
    </Button>
  );
};

export default TabCacheButton;
